/* eslint-disable @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment */
import type { Dispatch, GetState } from '@shopee/flow-types';
export { default as callApi2, isApiFailed } from './create_api_request_2';
export type {
  ApiResponse as ApiResponse2,
  ApiFailResponse,
  ApiSuccessResponse,
} from './create_api_request_2';

export type CallApiRequestAction = {
  payload?: (state: any, action: any, res?: any) => any;
  type: string;
};

export type ApiResponse<T> = {
  response?: T;
  error?: number;
};

export type CallApiActionType<T, R extends ApiResponse<T>> = {
  // This was Promise<*>, but that caused weird errors when used in react-native folder
  apiCall: () => Promise<R>;
  actions: [CallApiRequestAction, CallApiRequestAction, CallApiRequestAction];
  shouldSkipCall?: (state: any) => boolean;
  onFinish?: () => void;
  onSuccess?: () => void;
};

function getPayload(
  payload:
    | undefined
    | ((state: any, action: any, res: any) => any | null | undefined),
  state: any,
  action: any,
  res: any = null
) {
  if (!payload || typeof payload !== 'function') {
    return null;
  }
  return payload(state, action, res);
}

function isPromise(obj: any): boolean {
  return (
    !!obj &&
    (typeof obj === 'object' || typeof obj === 'function') &&
    typeof obj.then === 'function'
  );
}

export async function callApi<T, R extends ApiResponse<T>>(
  action: CallApiActionType<T, R>,
  dispatch: Dispatch,
  getState: GetState,
  requestId?: string
): Promise<R | null | undefined> {
  const {
    apiCall,
    actions: [requestAction, successAction, failAction],
    shouldSkipCall,
    onFinish,
    onSuccess,
  }: CallApiActionType<T, R> = action;
  // to improve performance
  if (typeof shouldSkipCall === 'function' && shouldSkipCall(getState())) {
    onFinish && onFinish();
    return null;
  }

  const requestPayload = getPayload(requestAction.payload, getState(), action);
  dispatch({
    payload: isPromise(requestPayload) ? await requestPayload : requestPayload,
    type: requestAction.type,
    requestId: requestId,
  });
  const res = await apiCall();

  if (res.error) {
    dispatch({
      payload: await getPayload(failAction.payload, getState(), action, res),
      error: res.error,
      type: failAction.type,
      requestId: requestId,
    });
  } else {
    dispatch({
      payload: await getPayload(
        successAction.payload,
        getState(),
        action,
        res.response
      ),
      type: successAction.type,
      requestId: requestId,
    });
    onSuccess && onSuccess();
  }
  onFinish && onFinish();

  return res;
}

export default callApi;
